import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    points: { type: Array, default: [] },
  };

  connect() {
    const Highcharts = window.Highcharts;
    if (typeof Highcharts === "undefined") return;

    const points = this.pointsValue;
    if (!Array.isArray(points) || points.length < 2) return;

    const lineColor =
      (Highcharts.getOptions().colors && Highcharts.getOptions().colors[0]) ||
      "#2563eb";

    this.chart = Highcharts.chart(this.element, {
      time: { useUTC: false },
      chart: {
        type: "line",
        height: 40,
        width: 112,
        margin: [2, 2, 2, 2],
        backgroundColor: "transparent",
        animation: false,
      },
      title: { text: null },
      legend: { enabled: false },
      credits: { enabled: false },
      xAxis: { visible: false, type: "datetime" },
      yAxis: { visible: false },
      plotOptions: {
        line: { marker: { enabled: false }, lineWidth: 1 },
      },
      tooltip: {
        formatter: function () {
          const date = Highcharts.dateFormat("%e %b %Y", this.x);
          const y =
            typeof this.y === "number" ? this.y.toFixed(3) : String(this.y);
          return `<span style="font-size:11px">${date}<br><b>${y}%</b></span>`;
        },
      },
      series: [{ data: points, enableMouseTracking: true, color: lineColor }],
    });
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
}
